import { io } from 'socket.io-client';
import { API_BASE } from '../components/config';

const getStoredToken = () => localStorage.getItem('token');

// Socket.IO starts with WebSocket when possible, and falls back to HTTP polling
// when a network or proxy cannot upgrade the connection.
const connectionOptions = {
  transports: ['websocket', 'polling'],
  tryAllTransports: true,
  upgrade: true,
  reconnection: true,
  reconnectionAttempts: Infinity,
  reconnectionDelay: 1000,
  reconnectionDelayMax: 5000,
  timeout: 15000
};

const socket = io(API_BASE, {
  ...connectionOptions,
  autoConnect: Boolean(getStoredToken()),
  auth: {
    token: getStoredToken()
  }
});

// Refresh authentication before every reconnect: the token may have changed
// after login while this singleton socket instance remains alive.
socket.io.on('reconnect_attempt', () => {
  socket.auth = { token: getStoredToken() };
});

socket.on('connect', () => {
  if (process.env.NODE_ENV !== 'production') {
    console.log('Socket connected:', socket.id);
  }
});

socket.on('disconnect', reason => {
  if (process.env.NODE_ENV !== 'production') {
    console.log('Socket disconnected:', reason);
  }
});

socket.on('connect_error', error => {
  if (process.env.NODE_ENV !== 'production') {
    console.warn('Socket connection error:', error.message);
  }

  // Authentication failures cannot recover by reconnecting. Clear the stale
  // login state and return the user to the login page.
  if (['Invalid token', 'No token'].includes(error.message)) {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    socket.disconnect();

    if (window.location.pathname !== '/') {
      window.location.assign('/');
    }
  }
});

export function connectSocket(token = getStoredToken()) {
  if (!token) return;

  socket.auth = { token };
  if (!socket.connected) socket.connect();
}

export function disconnectSocket() {
  socket.disconnect();
}

export function createMonitorSocket() {
  return io(API_BASE, {
    ...connectionOptions,
    auth: { monitor: true }
  });
}

export default socket;
